import { getProducts, host } from './api';
const state = {
    productList: [],
    navigatorList: [],
    filterList: [],
    pages: [],
    sortList: [{
        id: 'is_hot',
        name: '热销',
    }, {
        id: 'shop_price',
        name: '价格',
    }, {
        id: 'last_update',
        name: '新品',
    }],
    currPage: 1,
    currNavigator: 0,       //0全部
    currFilter: 0,          //0全部
    currSort: 'is_hot',
    currOrder: 'DESC',      //'DESC'箭头往下，正序，'ASC'反之
};

const mutations = {
    setProductList (state, productList) {
        state.productList = productList;
    },
    setNavigatorList (state, navigatorList) {
        state.navigatorList = navigatorList;
    },
    setFilterList (state, filterList) {
        state.filterList = filterList;
    },
    setPages (state, pages) {
        state.pages = pages;
    },
    setCurrPage (state, currPage) {
        state.currPage = currPage;
    },
    setCurrNavigator (state, currNavigator) {
        state.currNavigator = currNavigator;
    },
    setCurrFilter (state, currFilter) {
        state.currFilter = currFilter;
    },
    setCurrSort (state, currSort) {
        state.currSort = currSort;
    },
    setCurrOrder (state, currOrder) {
        state.currOrder = currOrder;
    },
};

const actions = {
    async getProducts ({commit, state}, {currNavigator, currPage, currFilter, currSort, currOrder}) {
        let {
            currNavigator: id,
            currPage: page,
            currFilter: filter_attr,
            currSort: sort,
            currOrder: order,
        } = state;
        if (currNavigator !== undefined) {
            id = currNavigator;
            page = 1;
            filter_attr = 0;
            currSort = 'is_hot';
            order = 'DESC';
            commit('setCurrPage', 1);
            commit('setCurrFilter', 0);
            commit('setCurrSort', 'shop_price');
            commit('setCurrOrder', 'DESC');
            commit('setCurrNavigator', currNavigator);
        }
        if (currPage !== undefined) {
            page = currPage;
            commit('setCurrPage', currPage);
        }
        if (currFilter !== undefined) {
            filter_attr = currFilter;
            commit('setCurrFilter', currFilter);
        }
        if (currSort !== undefined) {
            sort = currSort;
            commit('setCurrSort', currSort);
        }
        if (currOrder !== undefined) {
            order = currOrder;
            commit('setCurrOrder', currOrder);
        }
        return getProducts({id, page, filter_attr, sort, order}).then(res => {
            let {navigator_list, goods_list, filter_attr, pages} = res.data;
            navigator_list.unshift({
                name: '全部',
                cid: 0,
                url: 'supply.php?id=0',
            });
            goods_list = Object.keys(goods_list).map(item => {
                let {goods_thumb, shop_price} = goods_list[item];
                shop_price = Number(shop_price.replace('￥', '').replace('元', ''));
                goods_thumb = host + '/' + goods_thumb;
                return Object.assign(goods_list[item], {amount: 0, goods_thumb, shop_price});
            });
            commit('setProductList', goods_list);
            commit('setNavigatorList', navigator_list);
            commit('setFilterList', filter_attr);
            commit('setPages', pages);
        });
    }
};
const getters = {
    total: state => {
        const {productList} = state;
        let total = 0;
        productList.forEach(item => {
            const {amount, shop_price} = item;
            total += amount * shop_price;
        });
        return total;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};



// WEBPACK FOOTER //
// ./src/stores/addProduct.js